function initUpsellModule() {
  let upsellObserver;

  function loadInventoryFromSelect() {
    const select = document.getElementById("upsell-variant");
    if (!select) return {};
    try {
      return JSON.parse(select.getAttribute("data-inventory")) || {};
    } catch (e) {
      console.warn("Error leyendo inventario:", e);
      return {};
    }
  }

  function initUpsellQtyControls() {
    const select = document.getElementById("upsell-variant");
    const input = document.getElementById("upsell-qty");
    const addButton = document.getElementById("upsell-alt-button");
    if (!select || !input || !addButton) return;

    window.__upsellInventory__ = loadInventoryFromSelect();
    const upsellVariants = window.__upsellInventory__;

    const update = () => {
      const selectedId = select.value;
      const maxQty = upsellVariants[selectedId] || 1;
      input.max = maxQty;

      if (parseInt(input.value) > maxQty) input.value = maxQty;
      if (parseInt(input.value) < 1) input.value = 1;

      addButton.setAttribute("data-id", selectedId);
      addButton.setAttribute("data-qty", input.value);
    };

    select.addEventListener("change", update);
    input.addEventListener("input", update);
    input.addEventListener("change", update);
    update();
  }

  function handleQtyButtons(e) {
    const btn = e.target.closest("[data-qty-change]");
    if (!btn) return;

    const input = document.getElementById("upsell-qty");
    const select = document.getElementById("upsell-variant");
    const addButton = document.getElementById("upsell-alt-button");
    const upsellVariants = window.__upsellInventory__ || {};
    if (!input || !select || !addButton) return;

    const change = parseInt(btn.getAttribute("data-qty-change"), 10) || 0;
    const maxQty = upsellVariants[select.value] || 1;
    let newVal = parseInt(input.value || 1) + change;

    newVal = Math.max(1, Math.min(maxQty, newVal));
    input.value = newVal;
    addButton.setAttribute("data-id", select.value);
    addButton.setAttribute("data-qty", newVal);
  }

  // 🛒 Upsell alternativo (2da unidad)
  function handleUpsellProductAddClick(e) {
    const btn = e.target.closest('[data-action="add-upsell-alt-product"]');
    if (!btn) return;

    const select = document.getElementById("upsell-variant");
    const variantId = select?.value;
    const qty = parseInt(btn.getAttribute("data-qty")) || 1;

    if (!variantId || isNaN(qty)) {
      console.warn("❌ Variant ID inválido o cantidad inválida");
      return;
    }

    btn.disabled = true;
    btn.innerText = "Agregando...";

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const existingItem = cart.items.find((item) => item.variant_id == variantId);
        const upsellInventory = window.__upsellInventory__?.[variantId] || 1;

        const currentQty = existingItem?.quantity || 0;
        const finalQty = Math.min(currentQty + qty, upsellInventory);

        if (finalQty === currentQty) {
          alert("Ya alcanzaste el máximo disponible en stock.");
          throw new Error("Stock insuficiente");
        }

         const payload = existingItem
          ? { id: existingItem.key, quantity: finalQty }
          : { id: variantId, quantity: qty };

        const endpoint = existingItem ? "/cart/change.js" : "/cart/add.js";

        return fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json().catch(() => null);
          if (res.status === 400 && errorData?.description?.includes("already in your cart")) {
            console.warn("🟡 Producto ya en carrito, sin duplicar");
          } else {
            console.error("❌ Falló el fetch", res.status, errorData);
            throw new Error("Error real al agregar el producto");
          }
        }

        return updateCartSections();
      })
      .catch((err) => {
        console.error("🚨 Error al agregar producto upsell alt:", err);
        alert("Ocurrió un error al agregar el producto");
      })
      .finally(() => {
        btn.disabled = false;
        btn.innerText = "Agregar";
      });
  }

  // 🧮 Upsell por cantidad (break)
  // 🧮 Upsell por cantidad (break) — LÓGICA MIXTA (producto + variante)
  function handleUpsellBreakAddClick(e) {
    const btn = e.target.closest('[data-action="add-upsell-alt-break"]');
    if (!btn) return;

    const breakIndex = btn.getAttribute('data-break-index');
    const targetQty = parseInt(btn.getAttribute('data-qty'), 10);
    if (!breakIndex || isNaN(targetQty) || targetQty <= 0) return;

    // ✅ Selector correcto del <select>
    const select = document.querySelector(`select[data-break-index="${breakIndex}"]`);
    if (!select) return;

    const variantId = select.value;
    if (!variantId) return;

    // ➕ Necesitamos el product_id del producto al que pertenece ese select
    const productId = select.getAttribute('data-product-id');

    // Inventario por variante embebido en el select
    let inventoryData = {};
    try {
      inventoryData = JSON.parse(select.getAttribute('data-inventory')) || {};
    } catch (err) {
      console.warn('Error leyendo inventario de select:', err);
    }
    const maxInventory = parseInt(inventoryData[variantId], 10) || 9999;

    btn.disabled = true;
    const prevText = btn.innerText;
    btn.innerText = 'Agregando...';

    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        // Cantidad total de ESTE producto (todas sus variantes) en el carrito
        const productTotalQty = cart.items.reduce((acc, it) => {
          return acc + (String(it.product_id) === String(productId) ? (parseInt(it.quantity, 10) || 0) : 0);
        }, 0);

        // Línea (si existe) de la variante seleccionada
        const existingItem = cart.items.find((it) => String(it.variant_id) === String(variantId));
        const variantQty = existingItem ? (parseInt(existingItem.quantity, 10) || 0) : 0;

        // 📏 Regla MIXTA:
        // 1) Si el total del producto es menor al objetivo -> agregamos lo necesario para llegar al objetivo global.
        // 2) Si el total del producto ya alcanzó el objetivo:
        //    2.a) Si la variante está por debajo del objetivo -> completamos esa variante hasta el objetivo.
        //    2.b) Si la variante ya está en el objetivo -> sumamos el objetivo completo.
        let delta;
        if (productTotalQty < targetQty) {
          delta = targetQty - productTotalQty; // completar objetivo global
        } else if (variantQty < targetQty) {
          delta = targetQty - variantQty; // completar objetivo para la variante elegida
        } else {
          delta = targetQty; // sumar objetivo completo
        }

        // 📦 Tope por stock de la variante
        const allowed = Math.max(0, maxInventory - variantQty);
        if (delta > allowed) delta = allowed;

        if (delta <= 0) {
          alert('No hay suficiente stock disponible o ya alcanzaste el objetivo.');
          throw new Error('Sin delta / sin stock');
        }

        // Llamada a Shopify: change si existe línea, add si no existe
        if (existingItem) {
          const newQty = variantQty + delta;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existingItem.key, quantity: newQty }),
          });
        } else {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: delta }),
          });
        }
      })
      .then((res) => {
        if (!res.ok) throw new Error('Error al agregar el producto');
        return updateCartSections();
      })
      .catch((err) => {
        console.error('Error en upsell break:', err);
        alert('Ocurrió un error al agregar el producto');
      })
      .finally(() => {
        btn.disabled = false;
        btn.innerText = prevText;
      });
  }




  function updateCartSections() {
    const url = new URL(window.location.href);
    url.searchParams.set("sections", "cart-template,cart-count,cart-drawer");

    return fetch(url)
      .then((res) => res.json())
      .then((sectionsHTML) => {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          cart: {
            sections: {
              "cart-template": sectionsHTML["cart-template"],
              "cart-count": sectionsHTML["cart-count"],
              "cart-drawer": sectionsHTML["cart-drawer"],
            },
          },
        });

        // ✅ Forzamos reinit de qty selectores
        setTimeout(() => {
          initUpsellQtyControls();
        }, 100);

        document.dispatchEvent(new CustomEvent("cart:updated"));
      });
  }

  function observeUpsellQtyInput() {
    if (upsellObserver) upsellObserver.disconnect();

    upsellObserver = new MutationObserver(() => {
      const qtyInput = document.getElementById("upsell-qty");
      if (qtyInput && !qtyInput.hasAttribute("data-initialized")) {
        initUpsellQtyControls();
        qtyInput.setAttribute("data-initialized", "true");
      }
    });

    upsellObserver.observe(document.body, { childList: true, subtree: true });
  }

  function reinitOnEvent() {
    const tryInit = () => {
      const qtyInput = document.getElementById("upsell-qty");
      if (qtyInput && !qtyInput.hasAttribute("data-initialized")) {
        initUpsellQtyControls();
        qtyInput.setAttribute("data-initialized", "true");
      } else {
        setTimeout(tryInit, 100);
      }
    };
    tryInit();
  }

  function waitForInventoryAndInit(retries = 10) {
    if (document.getElementById("upsell-variant")?.getAttribute("data-inventory")) {
      window.__upsellInventory__ = loadInventoryFromSelect();
      observeUpsellQtyInput();
      initUpsellQtyControls();
    } else if (retries > 0) {
      setTimeout(() => waitForInventoryAndInit(retries - 1), 200);
    } else {
      console.warn("Upsell inventory no se cargó a tiempo.");
    }
  }

  function initUpsellSwiper() {
    const swiperContainer = document.querySelector("#upsell-swiper");
    if (!swiperContainer || typeof Swiper === "undefined") {
      return setTimeout(initUpsellSwiper, 300);
    }

    new Swiper("#upsell-swiper", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      observer: true,
      observeParents: true,
    });
  }

  waitForInventoryAndInit();
  initUpsellSwiper();
  document.addEventListener("click", handleQtyButtons);
  document.addEventListener("click", handleUpsellProductAddClick);
  document.addEventListener("click", handleUpsellBreakAddClick);
  document.addEventListener("cart:open", reinitOnEvent);
  document.addEventListener("cart:updated", () => {
    initUpsellSwiper();
    reinitOnEvent();
  });
}

document.addEventListener("DOMContentLoaded", initUpsellModule);
document.addEventListener("shopify:section:load", initUpsellModule);
